import React from "react";
import { style } from "typestyle";
import type { StrCoords } from "../tableReducer";

interface CoordsInputProps {
  coords: StrCoords;
  onChange: (coords: StrCoords) => void;
}

const CoordsInput = (props: CoordsInputProps) => {
  const { x, y, z } = props.coords;
  return (
    <div
      className={style({
        display: "flex",
        border: "1px solid #D7D7E1",
        borderRadius: "12px",
        overflow: "hidden",
        $nest: {
          "&>*": {
            width: "100%",
            padding: "10px 12px",
            border: "none",
            borderRight: "1px solid #D7D7E1",
            fontSize: "14px",
            lineHeight: "20px",
          },
          "&>*:last-child": {
            border: "none",
          },
        }
      })}
    >
      <input
        value={y}
        onChange={e =>
          props.onChange({
            ...props.coords,
            y: e.target.value,
          })
        }
      />
      <input
        value={x}
        onChange={e =>
          props.onChange({
            ...props.coords,
            x: e.target.value,
          })
        }
      />
      <input
        value={z}
        onChange={e =>
          props.onChange({
            ...props.coords,
            z: e.target.value,
          })
        }
      />
    </div>
  );
};

export default CoordsInput;
